import { Alert } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";

export const ReviewNavigation = ({
  confirmed,
  pending,
  error,
  onNavigate,
}: {
  confirmed: boolean;
  pending: boolean;
  error?: string;
  onNavigate: (direction: "back" | "next") => void;
}) => (
  <Stack className="w-full" gap={2} align="stretch">
    {error && (
      <Alert color={"danger"}>
        {error} Your information has not been submitted. Correct any missing
        information and try again.
      </Alert>
    )}
    <Stack
      className="w-full"
      align="start"
      direction="row"
      gap={2}
      justify="end"
    >
      <Button
        variant="ghost"
        disabled={pending}
        onClick={() => onNavigate("back")}
      >
        Back
      </Button>
      <Button
        disabled={!confirmed || pending}
        aria-busy={pending}
        onClick={() => onNavigate("next")}
      >
        Submit information
      </Button>
    </Stack>
  </Stack>
);
